import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import styled from '@emotion/styled'
import { css } from "@emotion/react"

// components
import Typography from '@material-ui/core/Typography'
import Copyright from "./copyright";

// resources
import LogoPath from '../../../../public/images/common/logo.svg'

const Footer = () => {
  return(
      <React.Fragment>
        <hr css={hrStyle}/>
        <Logo>
          <LogoPath />
        </Logo>
        <div css={boxStyle}>
          <Link href={'/items'}>
            <a css={pageNav}>
              <Typography css={{display: 'inline-block'}}>
                <span>商品一覧</span>
              </Typography>
            </a>
          </Link>
          <Link href={'/guide'}>
            <a css={pageNav}>
              <Typography css={{display: 'inline-block'}}>
                <span>ご利用ガイド／よくあるご質問</span>
              </Typography>
            </a>
          </Link>
          <div css={hrArea}>
            <hr css={hrStyle}/>
          </div>
          <Link href={'/company'}>
            <a css={otherLink}>
              <Typography css={{display: 'inline-block'}}>
                <span>会社概要</span>
              </Typography>
            </a>
          </Link>
          <Link href={'/privacy'}>
            <a css={otherLink}>
              <Typography css={{display: 'inline-block'}}>
                <span>個人情報保護方針</span>
              </Typography>
            </a>
          </Link>
          <Link href={'/law'}>
            <a css={otherLink}>
              <Typography css={{display: 'inline-block'}}>
                <span>特定商取引法に基づく表記</span>
              </Typography>
            </a>
          </Link>
          <Copyright/>
        </div>
      </React.Fragment>
  )
}

export default Footer;

let Logo = styled.div({
  maxWidth: '104px',
  textAlign: 'center',
  margin: '40px auto 32px',
})

const boxStyle = css`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  & a {
    text-decoration: none,
  }
`

const pageNav = css`
  margin:  8px 0;
  span {
    cursor: pointer;
    font-size: 1.8rem;
    font-weight: 500;
  }
`

const hrArea = css`
  max-width: 460px;
  width: 100%;
  margin: 24px 0;
`

const hrStyle = css`
  max-width: 90%;
  border: solid 1px #efefef;
`

const otherLink = css`
  margin: 4px 0;
  span {
    cursor: pointer;
    font-size: 1.4rem;
    font-weight: 400;
  }
`